import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect, Route, matchPath, withRouter } from 'react-router-dom';
import { setOriginalUrlParameters } from '../../shared/actions';
import AddEmail from '../addEmail/AddEmail';
import AddPhone from '../addPhone/AddPhone';
import Applications from '../applications/Applications';
import HelloPage from '../auth/HelloPage';
import LoginConfirmationPage from '../auth/LoginConfirmationPage';
import RegistrationPage from '../auth/RegistrationPage';
import AuthoritySelection from '../authoritySelection/AuthoritySelection';
import Calendar from '../calendar/Calendar';
import CalendarEvent from '../calendar/CalendarEvent';
import Discussions from '../discussions/Discussions';
import FAQS from '../faqs/FAQS';
import Home from '../home/Home';
import MessageDetails from '../messages/MessageDetails';
import Messages from '../messages/Messages';
import MyCity from '../myCity/MyCity';
import NewReport from '../newReport/NewReport';
import PublicPaymentAccess from '../payments/PublicPaymentAccess';
import PaymentConfirmation from '../payments/PaymentConfirmation';
import Payments from '../payments/Payments';
import PublicPaymentSuccess from '../payments/PublicPaymentSuccess';
import Phonebook from '../phonebook/Phonebook';
import Privacy from '../privacy/Privacy';
import Profile from '../profile/Profile';
import ReportDetails from '../reports/ReportDetails';
import Reports from '../reports/Reports';
import RouteHandler from '../route/RouteHandler';
import TutorialPageContainer from '../startup/Tutorial';







const AUTH_FLOW_ROUTES = [
  '/hello',
  '/login-confirmation',
  '/registration-page',
];

class ProtectedRoutes extends Component {
  componentDidMount() {
    this.rememberOriginalRoute();
  }

  componentDidUpdate(prevProps) {
    const prevPath = prevProps.location?.pathname;
    const nextPath = this.props.location?.pathname;
    const prevSearch = prevProps.location?.search;
    const nextSearch = this.props.location?.search;

    if (
      prevPath !== nextPath ||
      prevSearch !== nextSearch ||
      prevProps.token !== this.props.token ||
      prevProps.authority !== this.props.authority
    ) {
      this.rememberOriginalRoute();
    }
  }

  rememberOriginalRoute() {
    const {
      token,
      location,
      params,
      deeplinkData,
      setOriginalUrlParameters,
    } = this.props;
    if (!location) return;

    const pathName = location.pathname || '';
    if (token || AUTH_FLOW_ROUTES.includes(pathName)) {
      return;
    }

    const search = location.search || '';
    const requestedRoute = `${pathName}${search}`;

    const hasActiveDeeplink =
      deeplinkData && deeplinkData.needsDeeplinkRedirection;

    if (hasActiveDeeplink && params?.redirect_route) {
      return;
    }

    if (params?.redirect_route === requestedRoute) {
      return;
    }

    setOriginalUrlParameters({
      ...(params || {}),
      redirect_route: requestedRoute,
    });
  }

  render() {
    let { token, authority, mobile, location, modulesEnabled, deeplinkData } = this.props;
    const isPublicPaymentAccessRoute =
      location?.pathname === '/public/payment/access';
    const isPublicPaymentsRoute =
      location?.pathname?.startsWith('/public/payments');
    const isPublicPaymentSuccessRoute =
      location?.pathname === '/public/payment/success';
    let comp = null;
    const hasQueryParams = !!location?.search;
    const hasAppAccess = !!token && !!authority;
    const currentPathname = location?.pathname || '';



    const seenTutorial =
      hasAppAccess ||
      (typeof window !== 'undefined' &&
        localStorage.getItem('seenTutorial') === 'true');

    const isPublicRoute =
      isPublicPaymentAccessRoute ||
      isPublicPaymentsRoute ||
      isPublicPaymentSuccessRoute;

    if (
      !hasQueryParams &&
      !seenTutorial &&
      location?.pathname !== '/' &&
      !isPublicRoute
    ) {
      comp = <Redirect to="/" />;
    }

    let routes = createRoutesBasedOnModules(
      modulesEnabled,
      token,
      authority,
      mobile,
      seenTutorial,
      { deeplinkData }

    );

    const hasKnownRouteMatch = routes.some((entry) => {
      const routePath = entry?.props?.path;
      if (!routePath) return false;

      return !!matchPath(currentPathname, {
        path: routePath,
        exact: !!entry.props.exact,
      });
    });

    if (!hasKnownRouteMatch) {
      const query = new URLSearchParams(location?.search || '');
      const hasDeeplinkQueryParams =
        query.has('action') ||
        query.has('code') ||
        query.has('authority') ||
        query.has('country');

      if (hasDeeplinkQueryParams) {
        return <Redirect to={`/route${location?.search || ''}`} />;
      }

      return hasAppAccess ? (
        <Redirect to="/home" />
      ) : (
        <Redirect to="/hello" />
      );
    }

    if (!hasQueryParams && comp) {
      routes = [comp].concat(routes);
    }


    return routes;
  }
}

const createRouteWithRequirements = (
  component,
  url,
  requirements,
  injections,
  exact,
  seenTutorial,
  options = {}
) => {
  const { skipTutorialRedirect } = options;

  return (
    <Route
      exact={!!exact}
      key={url}
      path={url}
      render={() => {

        if (!skipTutorialRedirect && !seenTutorial && url !== '/') {
          return <Redirect to="/" />;
        }


        if (requirements.includes('token') && !injections.token) {
          return <Redirect to="/hello" />;
        }

        if (
          requirements.includes('unauthenticated') &&
          injections.token &&
          injections.authority
        ) {
          return <Redirect to="/home" />;
        }

        if (requirements.includes('mobile') && !injections.mobile) {
          return <Redirect to={`/addPhone#from=${url}`} />;
        }

        if (requirements.includes('authority') && !injections.authority) {
          console.log('Cae from URL:', url);

          return (
            <Redirect
              to={{
                pathname: '/authoritySelection',
                state: { from: url },
              }}
            />
          );
        }

        return component;
      }}
    />
  );
};

var mapStateToProps = (state, ownProps) => {
  return {
    token: state.authReducer.auth_token,
    mobile: state.profileReducer.profile.mobile,
    authority: state.profileReducer.profile.authority,
    modulesEnabled: state.otherReducer.modules,
    params: state.otherReducer.params,
    location: ownProps.location || state.router?.location,
    deeplinkData: state.deeplinkReducer,
  };
};

var mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setOriginalUrlParameters,
    },
    dispatch
  );

const ConnectedProtectedRoutes = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProtectedRoutes)
);
export default ConnectedProtectedRoutes;

//TODO: Find out why moving Switch here doesnt work.
//TODO: MOVE THIS

function createRoutesBasedOnModules(
  modulesEnabled,
  token,
  authority,
  mobile,
  seenTutorial,
  metadata
) {
  const modulesEnabledNamesArray = (modulesEnabled || []).map(
    (item) => item.name
  );
  const entries = [];

  const { deeplinkData } = metadata || {};

  const deepLinkCode = deeplinkData?.payload_code || null;

  if (!seenTutorial) {
    entries.push(
      createRouteWithRequirements(
        <TutorialPageContainer key={'tutorial-page'} />,
        '/',
        [],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  if (seenTutorial && !token) {
    entries.push(
      createRouteWithRequirements(
        <Redirect to="/hello" />,
        '/',
        ['unauthenticated'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  if (seenTutorial && token && !authority) {
    entries.push(
      createRouteWithRequirements(
        <Redirect to="/authoritySelection" />,
        '/',
        ['token'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }


  if (seenTutorial && token && authority) {
    entries.push(
      createRouteWithRequirements(
        <Redirect to="/home" />,
        '/',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  const defaultEntries = [
    createRouteWithRequirements(
      <HelloPage key={'hello-page'} />,
      '/hello',
      ['unauthenticated'],
      { token, authority },
      true,
      seenTutorial
    ),
    createRouteWithRequirements(
      <RouteHandler key={'route-handler'} />,
      '/route',
      [],
      {},
      false,
      seenTutorial,
      { skipTutorialRedirect: true }
    ),
    createRouteWithRequirements(
      <LoginConfirmationPage key={'login-confirmation'} />,
      '/login-confirmation',
      ['unauthenticated'],
      { token, authority },
      true,
      seenTutorial
    ),
    createRouteWithRequirements(
      <RegistrationPage key={'registration-page'} />,
      '/registration-page',
      ['unauthenticated'],
      { token, authority },
      true,
      seenTutorial
    ),
    createRouteWithRequirements(
      <AuthoritySelection key={'authority-selection'} />,
      '/authoritySelection',
      ['token'],
      { token, authority },
      false,
      seenTutorial
    ),
    createRouteWithRequirements(
      <Home key={'home-page'} />,
      '/home',
      ['token', 'authority'],
      { token, authority },
      true,
      seenTutorial
    ),

    createRouteWithRequirements(
      <AddEmail key={'add-email'} />,
      '/addEmail',
      ['token', 'authority'],
      { token, authority },
      false,
      seenTutorial
    ),
    createRouteWithRequirements(
      <AddPhone key={'add-phone'} />,
      '/addPhone',
      ['token', 'authority'],
      { token, authority },
      false,
      seenTutorial
    ),
    createRouteWithRequirements(
      <Profile key={'profile-page'} />,
      '/profile',
      ['token', 'authority'],
      { token, authority },
      false,
      seenTutorial
    ),
    createRouteWithRequirements(
      <Privacy key={'privacy-page'} />,
      '/privacy',
      ['token', 'authority'],
      { token, authority },
      false,
      seenTutorial
    ),
    createRouteWithRequirements(
      <PublicPaymentAccess key={'public-payment-access'} />,
      '/public/payment/access',
      ['unauthenticated'],
      {},
      true,
      seenTutorial,
      { skipTutorialRedirect: true }
    ),
  ];

  entries.push(...defaultEntries);

  // public payments (no auth needed)
  entries.push(
    createRouteWithRequirements(
      <Payments
        isPublic={true}
        preCompletedRF={deepLinkCode}
        key={'public-payments-page'} />,
      '/public/payments',
      [],
      { token, authority },
      true,
      seenTutorial,
      { skipTutorialRedirect: true }
    )
  );

  entries.push(
    createRouteWithRequirements(
      <PublicPaymentSuccess key={'public-payment-success'} />,
      '/public/payment/success',
      [],
      { token, authority },
      true,
      seenTutorial,
      { skipTutorialRedirect: true }
    )
  );

  entries.push(
    createRouteWithRequirements(
      <PaymentConfirmation
        isPublic={true}
        key={'public-payment-confirmation'}
      />,
      '/public/payments/:code',
      [],
      { token, authority },
      false,
      seenTutorial,
      { skipTutorialRedirect: true }
    )
  );



  if (modulesEnabledNamesArray.includes('messages')) {
    entries.push(
      createRouteWithRequirements(
        <Messages key={'messages-page'} />,
        '/messages',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
    entries.push(
      createRouteWithRequirements(
        <MessageDetails key={'message-details'} />,
        '/messages/:id',
        ['token', 'authority'],
        { token, authority },
        false,
        seenTutorial
      )
    );
  }

  if (modulesEnabledNamesArray.includes('mycity')) {
    entries.push(
      createRouteWithRequirements(
        <MyCity key={'my-city-page'} />,
        '/myCity',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  if (modulesEnabledNamesArray.includes('reports')) {
    entries.push(
      createRouteWithRequirements(
        <Reports key={'reports-page'} />,
        '/reports',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
    entries.push(
      createRouteWithRequirements(
        <ReportDetails key={'report-details'} />,
        '/reports/:id',
        ['token', 'authority'],
        { token, authority },
        false,
        seenTutorial
      )
    );

    entries.push(
      createRouteWithRequirements(
        <NewReport key={'new-report'} />,
        '/newReport',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  if (modulesEnabledNamesArray.includes('phones')) {
    entries.push(
      createRouteWithRequirements(
        <Phonebook key={'phonebook-page'} />,
        '/phonebook',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  if (modulesEnabledNamesArray.includes('faqs')) {
    entries.push(
      createRouteWithRequirements(
        <FAQS key={'faqs-page'} />,
        '/faqs',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  if (modulesEnabledNamesArray.includes('calendar')) {
    entries.push(
      createRouteWithRequirements(
        <Calendar key={'calendar-page'} />,
        '/calendar',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
    entries.push(
      createRouteWithRequirements(
        <CalendarEvent key={'calendar-event'} />,
        '/calendar/:eventId',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  // discussions
  if (modulesEnabledNamesArray.includes('discussions')) {
    entries.push(
      createRouteWithRequirements(
        <Discussions key={'discussions-page'} />,
        '/discussions',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  // bills and payments
  if (modulesEnabledNamesArray.includes('bills')) {
    entries.push(
      createRouteWithRequirements(
        <Payments key={'payments-page'} />,
        '/payments',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );

    entries.push(
      createRouteWithRequirements(
        <PaymentConfirmation key={'payment-confirmation'} />,
        '/payments/:code',
        ['token', 'authority'],
        { token, authority },
        false,
        seenTutorial
      )
    );
  }

  if (modulesEnabledNamesArray.includes('form_applications')) {
    entries.push(
      createRouteWithRequirements(
        <Applications key={'applications-page'} />,
        '/applications',
        ['token', 'authority'],
        { token, authority },
        true,
        seenTutorial
      )
    );
  }

  return entries;
}
